interface ICustomElement extends HTMLElement {
    onElementHeightChangeTimer?: number;
}

export const onElementHeightChange = (element: ICustomElement, callback: ICallback): ICallback => {
    try {
        const resizeObserver = new ResizeObserver(() => {
            callback();
        });

        resizeObserver.observe(element);

        return () => resizeObserver.unobserve(element);
    } catch (e) {
        let lastHeight = element.clientHeight;
        let newHeight;

        const run = (): ICallback => {
            newHeight = element.clientHeight;

            if (lastHeight !== newHeight) {
                callback();
            }

            lastHeight = newHeight;

            if (element.onElementHeightChangeTimer) {
                window.clearTimeout(element.onElementHeightChangeTimer);
            }

            element.onElementHeightChangeTimer = window.setTimeout(run, 200);

            return () => window.clearTimeout(element.onElementHeightChangeTimer);
        };

        return run();
    }
};
